// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"267":"0b8ca8fb","437":"86129a4d","787":"8251d91b","821":"d36a9876","917":"3f48d2ab"}[chunkId] + ".chunk.js";
};